import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@/components/Navigation/Buttons/AccountButton/accountButton.container"
    ).then((module) => ({ default: module.AccountButton }))
);
